<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { UserPlus, X } from '@lucide/vue';
import { api } from '../api/client';
// Совместный доступ к форме: владелец или администратор открывает форму коллегам-редакторам.
const props = defineProps<{ formId: string }>();
const access = ref<{ owner: any; users: any[]; canManage: boolean }>();
const directory = ref<any[]>([]);
const selectedUser = ref('');
const saving = ref(false);
const error = ref('');
const label = (user: any) => (user.name ? `${user.name} (${user.email})` : user.email);
// Администраторы и так видят все формы, поэтому в списке только редакторы.
const available = computed(() => directory.value.filter((user) => user.role !== 'admin' && user.id !== access.value?.owner?.id && !access.value?.users.some((item) => item.id === user.id)));
async function save(userIds: string[]) {
  saving.value = true; error.value = '';
  try { access.value = await api.setFormAccess(props.formId, userIds); selectedUser.value = ''; } catch (e: any) { error.value = e.message; } finally { saving.value = false; }
}
const add = () => selectedUser.value && save([...(access.value?.users ?? []).map((user) => user.id), selectedUser.value]);
const remove = (id: string) => save((access.value?.users ?? []).filter((user) => user.id !== id).map((user) => user.id));
onMounted(async () => {
  try {
    access.value = await api.formAccess(props.formId);
    if (access.value.canManage) directory.value = await api.userDirectory();
  } catch (e: any) { error.value = e.message; }
});
</script>
<template>
  <section class="consent-settings form-access">
    <div class="section-title"><span>Доступ к форме</span></div>
    <template v-if="access">
      <p class="field-help">Владелец: {{ access.owner ? label(access.owner) : 'администраторы' }}. Администраторы видят все формы.</p>
      <ul v-if="access.users.length" class="access-list">
        <li v-for="user in access.users" :key="user.id"><span>{{ label(user) }}<small v-if="!user.isActive"> · отключён</small></span><button v-if="access.canManage" type="button" class="icon-btn" title="Закрыть доступ" :disabled="saving" @click="remove(user.id)"><X :size="15"/></button></li>
      </ul>
      <p v-else class="field-help">Совместного доступа нет — форму, ответы и журнал согласий видят только владелец и администраторы.</p>
      <div v-if="access.canManage && available.length" class="access-add">
        <select v-model="selectedUser" class="control" aria-label="Пользователь"><option value="">Выберите коллегу</option><option v-for="user in available" :key="user.id" :value="user.id">{{ label(user) }}</option></select>
        <button type="button" class="btn btn-quiet" :disabled="!selectedUser || saving" @click="add"><UserPlus :size="16"/>Открыть</button>
      </div>
      <p v-else-if="!access.canManage" class="field-help">Открывать доступ может владелец формы или администратор.</p>
      <p v-else class="field-help">Нет редакторов, которым можно открыть доступ. Создайте их в разделе «Пользователи».</p>
    </template>
    <p v-if="error" class="field-error">{{ error }}</p>
  </section>
</template>
